import styled from 'styled-components';

const FieldGrid = styled.div`
  display: inline-grid;
  grid-auto-flow: ${props => props.gridFlow || 'column'};
  grid-gap: 10px;
`;

export default FieldGrid;
